import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getComplaint(context, id) {
        return axios
            .get(`/complaints/complaints/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych reklamacji wewnętrznej nie powiodło się.')

                return Promise.reject(error)
            })
    },

    createComplaint({ commit }, payload) {
        return axios
            .post('/complaints/complaints', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Reklamacja wewnętrzna została dodana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie reklamacji wewnętrznej nie powiodło się.')

                return Promise.reject(error)
            })
    },

    updateComplaint({ commit }, payload) {
        return axios
            .put(`/complaints/complaints/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Reklamacja wewnętrzna została zaktualizowana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja reklamacji wewnętrznej nie powiodło się.')

                return Promise.reject(error)
            })
    },

    copyComplaint({ commit, dispatch }, complaintId) {
        return dispatch('getComplaint', complaintId)
            .then(response => {
                commit('SET_COPIED_COMPLAINT', response.data)

                return Promise.resolve(response)
            })
    },

    clearStoredValues({ commit }) {
        commit('CLEAR_STORED_VALUES')
    },
}
